import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"; // Для навигации, если используете react-router
import { useLocation } from "react-router-dom";
import MainBodyModal from "./MainBodyModal";
import Api from "../Api";
import { BASE_API_URL } from "../const";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
  IconButton,
  TextField,
  Button,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import filmStore from "../../Store/FilmStore";
import { observer } from "mobx-react-lite";

const FilmData = observer(() => {
  const { repeatLastFilmListRequest } = filmStore;

  const [responseAPI, setResponseAPI] = useState(null);
  const [responseHistory, setResponseHistory] = useState();
  const [responseFilmList, setResponseFilmList] = useState();
  const [responseListChannels, setResponseListChannels] = useState();

  const location = useLocation();
  const [filmId, setFilmId] = useState(null);

  useEffect(() => {
    if (filmId) getDataFilmWithID();
  }, []);

  useEffect(() => {
    // Извлечение параметров из URL
    const params = new URLSearchParams(location.search);
    const id = params.get("id");

    // Установка id фильма в состояние
    if (id) {
      setFilmId(id);
      // Здесь вы можете вызвать API или выполнить другое действие с этим id
    }
  }, [location]);

  useEffect(() => {
    if (filmId !== null) {
      getDataFilmWithID(filmId);
      getDataFilmHistory(filmId);
      getDataFilmList(1);
      getDataListChannels();
    }
  }, [filmId]);

  async function getDataFilmWithID(id) {
    try {
      const response = await Api.get(`${BASE_API_URL}/api/movie/${id}`);
      setResponseAPI(response.data.data);
    } catch (error) {
      console.error(error);
    }
  }
  async function getDataFilmHistory(id) {
    try {
      const response = await Api.get(`${BASE_API_URL}/api/movie/history/${id}`);
      setResponseHistory(response.data.data);
    } catch (error) {
      console.error(error);
    }
  }
  //------- новый код
  const [openModal, setOpenModal] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState("");
  const [selectedChannelName, setSelectedChannelName] = useState("");
  const [selectedValue, setSelectedValue] = useState(""); // Select value
  const [checkboxValues, setCheckboxValues] = useState([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [formData, setFormData] = useState({
    channel_id: null,
    files_id: [],
  });

  useEffect(() => {
    // console.log("responseAPI " + JSON.stringify(responseAPI));
    if (responseAPI) {
      const filteredFiles = responseAPI.files.map((item) => ({
        id: item.file_id,
        name: item.name,
      }));
      setCheckboxValues(filteredFiles); // Обновление состояния
    }
  }, [selectedFormat, selectedChannelName, responseFilmList]); // Зависимости: формат и данные

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData, // Сохраняем остальные поля объекта formData
      files_id: selectedCheckboxes, // Обновляем только поле files_id
    }));
  }, [selectedCheckboxes]);

  const handleOpenModal = (format) => {
    setSelectedFormat(format);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedFormat();
  };
  const handleClickSendData = () => {
    if (
      formData.channel_id !== null &&
      Array.isArray(formData.files_id) &&
      formData.files_id.length > 0
    )
      Api.post(`${BASE_API_URL}/api/timeline/add`, formData)
        .then((response) => {})
        .catch((error) => {
          console.log("transfer bad");
          console.error("transfer bad", error);

          // проверяем есть ли структура с code/message
          const msg =
            error?.response?.data?.error?.message ||
            error?.message ||
            "transfer bad";

          alert(`Ошибка: ${msg}`);
        })
        .finally(() => {
          handleCloseModal();
        });
  };
  async function getDataListChannels() {
    try {
      const response = await Api.get(`${BASE_API_URL}/api/channel/list`);
      setResponseListChannels(response.data.data);
    } catch (error) {
      console.error(error);
    }
  }

  async function getDataFilmList(numberPage) {
    Api.post(`${BASE_API_URL}/api/filter?page=${numberPage}`, {})
      .then((response) => {
        setResponseFilmList(response);
      })
      .catch((error) => {
        console.log("transfer bad");
        console.error("transfer bad", error);

        // проверяем есть ли структура с code/message
        const msg =
          error?.response?.data?.error?.message ||
          error?.message ||
          "transfer bad";

        alert(`Ошибка: ${msg}`);
      })
  }
  useEffect(() => {
    if (responseAPI) {
      setInputValue(
        responseAPI.met_uid !== undefined && responseAPI.met_uid !== null
          ? String(responseAPI.met_uid)
          : ""
      );
      document.title = responseAPI.title;
      if (!responseAPI.met_uid) setBorderColorMet("gray");
    }
  }, [responseAPI]);
  //------ новый код

  //--- для нового поля
  const [inputValue, setInputValue] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  const [borderColorMet, setBorderColorMet] = useState("blue");
  const [labelText, setLabelText] = useState("met_uid");
  const [isEditMetUid, setIsEditMetUid] = useState(false);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
    setLabelText("met_uid");
    setBorderColorMet("red");
  };

  const handleSend = async () => {
    try {
      await setMetUid(filmId);
      setLabelText("изменено");
      setBorderColorMet("blue");
      setIsDisabled(true);
      setIsEditMetUid(true);
      filmStore.repeatLastFilmListRequest();
    } catch {
      alert("transfer met_uid bad");
    }
  };
  useEffect(() => {
    if (isEditMetUid && inputValue === responseAPI.met_uid) {
      setIsDisabled(false);
    } else {
      setIsDisabled(
        inputValue === "" ||
          labelText === "изменено" ||
          inputValue === responseAPI.met_uid
      );
    }
  }, [inputValue]);

  async function setMetUid(id) {
    Api.post(`${BASE_API_URL}/api/movie/met/${id}`, {
      met_uid: inputValue,
    });
  }

  return (
    <Box sx={{ padding: 2 }}>
      {/* Заголовок с голубым фоном и закругленными углами */}
      <Paper
        sx={{
          backgroundColor: "#E0F7FA", // Светло-голубой цвет
          padding: 2,
          borderRadius: 2,
          marginBottom: 2, // Отступ снизу
          display: "flex", // Для выравнивания иконки и заголовка в одну линию
          alignItems: "center",
        }}
      >
        {/* Иконка "домой" с ссылкой */}
        <Link to="/" style={{ textDecoration: "none" }}>
          <IconButton>
            <HomeIcon sx={{ color: "#00796B" }} /> {/* Цвет иконки */}
          </IconButton>
        </Link>

        {/* Заголовок по центру */}
        <Typography
          variant="h5"
          align="center"
          color="primary"
          sx={{ flexGrow: 1 }}
        >
          {responseAPI && responseAPI.title}
        </Typography>
      </Paper>

      {/* Контейнер для трёх колонок */}
      <Box sx={{ display: "flex", gap: 2 }}>
        {/* Первая колонка - 25%, с изображением по центру */}
        <Box
          sx={{
            flex: "0 0 25%", // Ширина 25%
            backgroundColor: "#F5F5F5", // Серый фон для примера
            padding: 2,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start", // Центрирование по горизонтали
            alignItems: "center", // Центрирование по вертикали
            borderRadius: 1,
          }}
        >
          {responseAPI && responseAPI.poster ? (
            <img
              src={responseAPI.poster}
              alt="Постер фильма"
              width="280"
              height="420"
              style={{ borderRadius: "8px" }}
            />
          ) : (
            <Typography>Загрузка изображения...</Typography>
          )}
          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              marginTop: 2,
              overflow: "auto",
              height: "300px",
            }}
          >
            {responseHistory && (
              <Table>
                <TableBody>
                  {responseHistory.map((row, index) => {
                    // Извлекаем только дату без времени
                    const date = row.start.split(" ")[0];
                    return (
                      <TableRow key={index}>
                        {/* Левая колонка: Дата */}
                        <TableCell sx={{ padding: "4px" }}>{date}</TableCell>

                        {/* Правая колонка: Канал с цветовой индикацией */}
                        <TableCell sx={{ padding: "4px" }}>
                          <Typography
                            sx={{
                              color:
                                row.status === 0
                                  ? "red"
                                  : row.status === 1
                                  ? "green"
                                  : "inherit",
                            }}
                          >
                            {row.channel}
                          </Typography>
                        </TableCell>
                        {row.season !== 0 && (
                          <>
                            <TableCell sx={{ padding: "4px" }}>
                              <Typography>Сезон {row.season}</Typography>
                            </TableCell>
                            <TableCell sx={{ padding: "4px" }}>
                              <Typography>Серия {row.episode}</Typography>
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            )}
          </TableContainer>
        </Box>

        {/* Центральная колонка - 50%, таблица с объектом "data" */}
        <Box
          sx={{
            flex: "0 0 50%", // Ширина 50%
            backgroundColor: "#E8EAF6", // Голубой фон для примера
            padding: 2,
            borderRadius: 1,
          }}
        >
          <Typography variant="h6" align="center" gutterBottom>
            Информация о фильме
          </Typography>

          {responseAPI ? (
            <TableContainer>
              <Table>
                <TableBody>
                  {Object.entries(responseAPI)
                    .filter(([key]) => key !== "files")
                    .filter(([key]) => key !== "poster")
                    .filter(([key]) => key !== "count")
                    .filter(([key]) => key !== "serial")
                    .filter(([key]) => key !== "id")
                    .filter(([key]) => key !== "format")
                    .filter(([key]) => key !== "met_uid")
                    .map(([key, value]) => (
                      <TableRow key={key}>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          {String(key)}:
                        </TableCell>
                        <TableCell>
                          {Array.isArray(value)
                            ? value.map((item, index) =>
                                typeof item === "object" ? (
                                  <Box key={index} sx={{ marginBottom: 1 }}>
                                    {Object.entries(item).map(
                                      ([subKey, subValue]) => (
                                        <Typography key={subKey}>
                                          {subKey}: {String(subValue)}
                                        </Typography>
                                      )
                                    )}
                                  </Box>
                                ) : (
                                  <Typography key={index} component="span">
                                    {item}
                                    {index < value.length - 1 ? ", " : ""}
                                  </Typography>
                                )
                              )
                            : typeof value === "object" && value !== null
                            ? JSON.stringify(value)
                            : String(value)}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography>Загрузка данных...</Typography>
          )}
        </Box>

        {/* Правая колонка - 25% */}
        <Box
          sx={{
            flex: "0 0 18%",
            backgroundColor: "#F5F5F5", // Серый фон для примера
            padding: 2,
            borderRadius: 1,
          }}
        >
          {/* <Typography variant="body1">выборка качества</Typography> */}
          <Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2, // Расстояние между строками
                width: "100%", // Полная ширина контейнера
              }}
            >
              <TextField
                label={labelText}
                variant="outlined"
                value={inputValue}
                onChange={handleInputChange}
                fullWidth
                autoComplete="off"
                inputProps={{ form: "off" }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: borderColorMet, // Задаем цвет рамки
                    },
                    "&:hover fieldset": {
                      borderColor: borderColorMet,
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: borderColorMet,
                    },
                  },
                }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handleSend}
                disabled={isDisabled}
              >
                изменить met_uid
              </Button>
              {/* <button onClick={() => filmStore.repeatLastFilmListRequest()}>
                Повторить запрос
              </button> */}
            </Box>
            <TableContainer
              component={Paper}
              sx={{ maxHeight: "calc(100% - 40px)", marginTop: 3 }}
            >
              <Table>
                <TableBody>
                  {
                    <TableRow>
                      <TableCell>
                        {responseAPI &&
                          responseAPI.format.map((item, index) => (
                            <span
                              key={index}
                              onClick={() => handleOpenModal(item.format)}
                              style={{
                                cursor: "pointer",
                                textDecoration: "underline",
                                marginRight: "15px",
                              }}
                            >
                              {item.format}
                            </span>
                          ))}
                      </TableCell>
                    </TableRow>
                  }
                </TableBody>
              </Table>
            </TableContainer>
            {responseAPI && openModal && selectedFormat && (
              <MainBodyModal
                openModal={openModal}
                handleCloseModal={handleCloseModal}
                responseAPI={responseAPI}
                selectedFormat={selectedFormat}
                repeatLastFilmListRequest={filmStore.repeatLastFilmListRequest}
              />
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
});

export default FilmData;
